/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const WebhookConfigurationEnabledAsJSONParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('enabled')],
    ['templateUrl', /* #__PURE__ */ parsers.maybeNull(codecString), 'template_url'],
    [
        'templateTokenId',
        /* #__PURE__ */ parsers.maybeNull(codecString),
        'template_token_id',
    ],
]);
export class WebhookConfigurationEnabledAsJSON extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return WebhookConfigurationEnabledAsJSONParser.decode(input).map(res => new WebhookConfigurationEnabledAsJSON(res));
    }
    static unsafeDecode(input) {
        return WebhookConfigurationEnabledAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return WebhookConfigurationEnabledAsJSONParser.encode(data);
    }
    static schema() {
        return WebhookConfigurationEnabledAsJSONParser.schema();
    }
}
